<template>
  <div id="zoovu-assistant"></div>
</template>

<script>
import {Url} from '@/utils/url.js';
import {mapState} from 'vuex';
export default {
  props: {
    sizeLinkGuide: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    currentLocale() {
      return this.locale?.toLowerCase().replace('_', '-') ?? 'en-us';
    },
    ...mapState(['locale']),
  },
  created() {
    this.addUrlParams();
    this.appendScript();
  },
  methods: {
    appendScript() {
      const script = document.createElement('script');
      script.src = `https://api-barracuda.zoovu.com/api/v1/advisors/xSTSZBsF/js-loader?locale=${this.currentLocale}`;
      document.head.appendChild(script);
    },
    resetSizeFinderParams() {
      let updatedUrl = Url.update(window.location.href, undefined, {removeKeys: ['step', 'section']});
      const queryParams = Url.parse(updatedUrl);

      // we need unique logic to remove the aid[xxx] params
      const sizeFinderRegex = new RegExp(/aid(\[|%5B)\d+(\]|%5D)/g);

      const filteredQueryParams = Object.entries(queryParams).filter((key) => {
        return sizeFinderRegex.test(key);
      });

      updatedUrl = Url.update(updatedUrl, undefined, {removeKeys: filteredQueryParams.map((entry) => entry[0])});
      window.history.replaceState(null, document.title, updatedUrl);
    },
    addUrlParams() {
      this.resetSizeFinderParams();
      let bikeCategory = '';
      if (window.location.href.indexOf('road') !== -1) {
        bikeCategory = '122747';
      } else if (window.location.href.indexOf('mountain') !== -1) {
        bikeCategory = '122746';
      } else if (
        window.location.href.indexOf('city') |
        window.location.href.indexOf('hybrid') |
        (window.location.href.indexOf('commuter') !== -1)
      ) {
        bikeCategory = '122745';
      }
      if (window.location.pathname.indexOf('electra') === -1) {
        const urlCode = `${encodeURIComponent('aid[39899]')}=${bikeCategory}&step=1`;
        window.history.replaceState(null, document.title, Url.appendUrl(window.location.href, urlCode));
      }
    },
  },
};
</script>

<style></style>
